import React, { useState, useMemo } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
} from '@mui/material'
import {
  Search as SearchIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  Edit as EditIcon,
  Business,
} from '@mui/icons-material'
import { useAuth } from '../../Auth/AuthProvider';
import { empresasAPI } from '../../Conections/EmpresaConection';
import { useNavigate } from 'react-router-dom';

import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import ErrorCard from '../../Conections/ErrorCard';
import { can } from '../../Conections/LogConections';


const initialData = [
  { id: 0, name: '', nit: '', phone: '', address: '', web: "", email: "" },
]

export default function ListCompanies() {

  const { getToken, getCompany } = useAuth();
  const goTo = useNavigate();
  const [data, setData] = useState(initialData);
  const [sortConfig, setSortConfig] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [permitido, setPermitido] = React.useState(false);
  const [showPermitido, setShowPermitido] = React.useState(false);
  const [editRepPermitido, setEditRepPermitido] = React.useState(false);

  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (getToken()) {
      const permisionCan = await can(getToken(), getCompany(), "/dashboard/com/listcompanies");
      if (permisionCan) {
        const showPermisionCan = await can(getToken(), getCompany(), "/dashboard/com/showcompany/:id");
        const represPermisionCan = await can(getToken(), getCompany(), "/dashboard/com/createrepresentative/:id");
        setShowPermitido(showPermisionCan);
        setEditRepPermitido(represPermisionCan);
        const datos = await empresasAPI(getToken(), getCompany());
        if (typeof datos[0] === "number") {
          setPermitido(false);
        } else {
          const newSelected = datos.map(
            (dato) => ({
              "id": dato.id,
              "name": dato.name,
              "nit": dato.nit,
              "phone": dato.phone,
              "address": dato.address,
              "web": dato.web,
              "email": dato.email,
            }));
          setData(newSelected);
          setPermitido(true);
        }
      }
      else {
        goTo("/dashboard");
      }
    }
    else {
      goTo("/login");
    }
  }

  const sortData = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    setSortConfig({ key, direction })
  }

  const sortedAndFilteredData = useMemo(() => {
    let sortableData = [...data]
    if (searchTerm) {
      sortableData = sortableData.filter(
        item =>
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.phone.includes(searchTerm) ||
          item.address.toLowerCase().includes(searchTerm.toLowerCase())
      )
    }
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1
        }
        return 0
      })
    }
    return sortableData
  }, [data, sortConfig, searchTerm])

  const handleEdit = (id) => {
    console.log(`Editar persona con ID: ${id}`)
  }


  return (
    permitido ? (
      <Paper sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ p: 3, flexGrow: 0 }}>
          <Typography variant="h4" gutterBottom color="primary">
            List Companies
          </Typography>
        </Box>
        <Box sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'flex-end' }}>
            <SearchIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
            <TextField
              label="Buscar"
              variant="standard"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              fullWidth
            />
          </Box>
          {selectedPerson && (
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              {showPermitido ? (
                <Button
                  startIcon={<Business />}
                  onClick={() => goTo(`/dashboard/com/showcompany/${selectedPerson.id}`)}
                  sx={{ mr: 1 }}
                >
                  Show
                </Button>
              ) : (
                <></>
              )
              }
              <Button
                startIcon={<EditIcon />}
                onClick={() => handleEdit(selectedPerson.id)}
                sx={{ mr: 1 }}
              >
                Editar
              </Button>
              {
                editRepPermitido ? (

                  <Button
                    startIcon={<PersonAddAltIcon />}
                    onClick={() => goTo(`/dashboard/com/createrepresentative/${selectedPerson.id}`)}
                    sx={{ mr: 1 }}
                  >
                    Representative
                  </Button>
                ) : (
                  <></>
                )
              }
            </Box>
          )}
          <TableContainer component={Paper} sx={{ flexGrow: 1, overflow: 'auto' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {['name', 'nit', 'phone', 'address', 'web', 'email'].map((key) => (
                    <TableCell
                      key={key}
                      onClick={() => sortData(key)}
                      sx={{ cursor: 'pointer' }}
                    >
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                      {sortConfig?.key === key && (
                        sortConfig.direction === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedAndFilteredData.map((person) => (
                  <TableRow
                    key={person.id}
                    onClick={() => setSelectedPerson(person)}
                    selected={selectedPerson?.id === person.id}
                    hover
                  >
                    <TableCell>{person.name}</TableCell>
                    <TableCell>{person.nit}</TableCell>
                    <TableCell>{person.phone}</TableCell>
                    <TableCell>{person.address}</TableCell>
                    <TableCell>{person.web}</TableCell>
                    <TableCell>{person.email}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {selectedPerson && (
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              {showPermitido ? (
                <Button
                  startIcon={<Business />}
                  onClick={() => goTo(`/dashboard/com/showcompany/${selectedPerson.id}`)}
                  sx={{ mr: 1 }}
                >
                  Show
                </Button>
              ) : (
                <></>
              )
              }
              <Button
                startIcon={<EditIcon />}
                onClick={() => handleEdit(selectedPerson.id)}
                sx={{ mr: 1 }}
              >
                Editar
              </Button>
              {
                editRepPermitido ? (

                  <Button
                    startIcon={<PersonAddAltIcon />}
                    onClick={() => goTo(`/dashboard/com/createrepresentative/${selectedPerson.id}`)}
                    sx={{ mr: 1 }}
                  >
                    Representative
                  </Button>
                ) : (
                  <></>
                )
              }
            </Box>
          )}
        </Box>
      </Paper>
    ) : (
      <ErrorCard />
    )
  )
}